// extracted by mini-css-extract-plugin
module.exports = {"button_row":"Order_button_row__2HWxE","btns":"Order_btns__27C4M","success":"Order_success__5Sa5q","red":"Order_red__27XZc","danger":"Order_danger__3yOFS","row":"Order_row__3_4OY"};